import React from 'react';
import { FaTimes } from 'react-icons/fa';
import './css/AppDrawer.css';

const AppDrawer = ({ open, title, onClose, children }) => {
    if (!open && !children) return null;

    return (
        <>
            {open && (
                <div className="app-drawer-overlay" onClick={onClose} />
            )}
            <div className={`app-drawer ${open ? 'open' : ''}`}>
                <div className="app-drawer-header">
                    <h3 className="app-drawer-title">{title}</h3>
                    <button className="app-drawer-close" onClick={onClose} aria-label="Close">
                        <FaTimes />
                    </button>
                </div>
                <div className="app-drawer-body">
                    {children}
                </div>
            </div>
        </>
    );
};

export default AppDrawer;
